import Vue from 'vue'
import Router from 'vue-router'

const Home = resolve => require(['@/views/Home'], resolve)
const StopWatch = resolve => require(['@/views/StopWatch'], resolve)
const StopWatchEx = resolve => require(['@/views/StopWatchEx'], resolve)
const StopWatchAdd = resolve => require(['@/views/StopWatchAdd'], resolve)

const Countdown = resolve => require(['@/views/Countdown'], resolve)
const CountdownEx = resolve => require(['@/views/CountdownEx'], resolve)
const CountdownDetail = resolve => require(['@/views/CountdownDetail'], resolve)
const CountdownStep = resolve => require(['@/views/CountdownStep'], resolve)

const FullscreenClock = resolve => require(['@/views/FullscreenClock'], resolve)
const FullscreenCountdown = resolve => require(['@/views/FullscreenCountdown'], resolve)
const Date = resolve => require(['@/views/Date'], resolve)
const Date2 = resolve => require(['@/views/Date2'], resolve)
const CalculatorDay = resolve => require(['@/views/CalculatorDay'], resolve)
const CalculatorTime = resolve => require(['@/views/CalculatorTime'], resolve)
const CalculatorDayList = resolve => require(['@/views/CalculatorDayList'], resolve)
const Clock = resolve => require(['@/views/Clock'], resolve)
const ClockSettings = resolve => require(['@/views/ClockSettings'], resolve)
const ClockAdd = resolve => require(['@/views/ClockAdd'], resolve)
const Time2 = resolve => require(['@/views/Time2'], resolve)
const Day = resolve => require(['@/views/Day'], resolve)
const DayAdd = resolve => require(['@/views/DayAdd'], resolve)
const Calendar = resolve => require(['@/views/Calendar2'], resolve)
const Calendar2 = resolve => require(['@/views/Calendar2'], resolve)
const Zodiac = resolve => require(['@/views/Zodiac'], resolve)
const ZodiacHelp = resolve => require(['@/views/ZodiacHelp'], resolve)
const Zodiac2 = resolve => require(['@/views/Zodiac2'], resolve)
const TimeAdjusting = resolve => require(['@/views/TimeAdjusting'], resolve)
const SolarTerm = resolve => require(['@/views/SolarTerm2'], resolve)
const SolarTermHelp = resolve => require(['@/views/SolarTermHelp2'], resolve)
const Lunar = resolve => require(['@/views/Lunar'], resolve)
const Death = resolve => require(['@/views/Death'], resolve)
const TimeConvert = resolve => require(['@/views/TimeConvert'], resolve)
const Age = resolve => require(['@/views/Age'], resolve)
const LunarTable = resolve => require(['@/views/LunarTable'], resolve)
const FullscreenTime = resolve => require(['@/views/FullscreenTime'], resolve)
const Clock4 = resolve => require(['@/views/Clock4'], resolve)
const Clock5 = resolve => require(['@/views/Clock5'], resolve)
const Clock6 = resolve => require(['@/views/Clock6'], resolve)
const NowTime = resolve => require(['@/views/NowTime'], resolve)
const WorldTime = resolve => require(['@/views/WorldTime'], resolve)
const WorldTimeDetail = resolve => require(['@/views/WorldTimeDetail'], resolve)
const StepTimer = resolve => require(['@/views/StepTimer'], resolve)
const Print = resolve => require(['@/views/Print'], resolve)
const PrintMonth = resolve => require(['@/views/PrintMonth'], resolve)
const PrintMonth2 = resolve => require(['@/views/PrintMonth2'], resolve)
const PrintYear = resolve => require(['@/views/PrintYear'], resolve)
const CountdownMoment = resolve => require(['@/views/CountdownMoment'], resolve)
const Error404 = resolve => require(['@/views/error/Error404'], resolve)

Vue.use(Router)

let routes = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/print',
        component: Print
    },
    { path: '/calendar/weapp', component: resolve => require(['@/views/CalendarWeapp'], resolve) },
    { path: '/debug', component: resolve => require(['@/views/Debug'], resolve) },
    { path: '/log', component: resolve => require(['@/views/Log'], resolve) },
    { path: '/record', component: resolve => require(['@/views/Record'], resolve) },
    { path: '/format', component: resolve => require(['@/views/Format'], resolve) },
    { path: '/format/date', component: resolve => require(['@/views/FormatDate'], resolve) },
    { path: '/sum', component: resolve => require(['@/views/Sum'], resolve) },
    { path: '/timeTable', component: resolve => require(['@/views/TimeTable'], resolve) },
    { path: '/timeTable/print', component: resolve => require(['@/views/TimeTablePrint'], resolve) },
    { path: '/currentTime', component: resolve => require(['@/views/Current'], resolve) },
    { path: '/go', component: resolve => require(['@/views/Go'], resolve) },
    { path: '/goOffWork', component: resolve => require(['@/views/GooffWork'], resolve) },
    { path: '/stopWatchSm', component: resolve => require(['@/views/StopWatchSmall'], resolve) },
    { path: '/time/plugin', component: resolve => require(['@/views/TimePlugin'], resolve) },
    { path: '/countdown/plugin', component: resolve => require(['@/views/CountdownPlugin'], resolve) },
    { path: '/go/plugin', component: resolve => require(['@/views/GoPlugin'], resolve) },
    { path: '/time/list', component: resolve => require(['@/views/TimeList'], resolve) },
    { path: '/week', component: resolve => require(['@/views/Week'], resolve) },
    {
        path: '/print/month',
        component: PrintMonth
    },
    {
        path: '/print/month2',
        component: PrintMonth2
    },
    {
        path: '/print/year',
        component: PrintYear
    },
    {
        path: '/countdown/moment',
        component: CountdownMoment
    },
    {
        path: '/time2',
        component: Time2
    },
    {
        path: '/nowTime',
        component: NowTime
    },
    {
        path: '/time/fullscreen',
        component: FullscreenTime
    },
    {
        path: '/calendar',
        component: Calendar
    },
    {
        path: '/calendar2',
        component: Calendar2
    },
    {
        path: '/stopWatch',
        component: StopWatch
    },
    {
        path: '/stopWatchEx',
        component: StopWatchEx
    },
    {
        path: '/stopWatch/add',
        component: StopWatchAdd
    },
    {
        path: '/stopWatchs/:id/edit',
        component: StopWatchAdd
    },
    {
        path: '/countdown',
        component: Countdown
    },
    {
        path: '/countdownEx',
        component: CountdownEx
    },
    {
        path: '/countdowns/:id',
        component: CountdownDetail
    },
    {
        path: '/countdownStep',
        component: CountdownStep
    },
    {
        path: '/clock/fullscreen',
        component: FullscreenClock
    },
    {
        path: '/countdown/fullscreen',
        component: FullscreenCountdown
    },
    {
        path: '/calculator/time',
        component: CalculatorTime
    },
    {
        path: '/calculator/day',
        component: CalculatorDay
    },
    {
        path: '/calculator/dayList',
        component: CalculatorDayList
    },
    {
        path: '/calculator/date',
        component: Date
    },
    {
        path: '/calculator/date2',
        component: Date2
    },
    {
        path: '/clock',
        component: Clock
    },
    {
        path: '/clock/settings',
        component: ClockSettings
    },
    {
        path: '/clock/add',
        component: ClockAdd
    },
    {
        path: '/day',
        component: Day
    },
    {
        path: '/day/add',
        component: DayAdd
    },
    {
        path: '/zodiac',
        component: Zodiac
    },
    {
        path: '/zodiac/help',
        component: ZodiacHelp
    },
    {
        path: '/zodiac2',
        component: Zodiac2
    },
    {
        path: '/time/adjusting',
        component: TimeAdjusting
    },
    {
        path: '/solarTerm',
        component: SolarTerm
    },
    {
        path: '/solarTerm/help',
        component: SolarTermHelp
    },
    {
        path: '/lunar',
        component: Lunar
    },
    {
        path: '/death',
        component: Death
    },
    {
        path: '/timeConvert',
        component: TimeConvert
    },
    {
        path: '/age',
        component: Age
    },
    {
        path: '/lunar/table',
        component: LunarTable
    },
    { path: '/true_time', component: resolve => require(['@/views/TrueTime'], resolve) },
    { path: '/monitor/weapp', component: resolve => require(['@/views/MonitorWeapp'], resolve) },
    {
        path: '/clock4',
        component: Clock4
    },
    {
        path: '/clock5',
        component: Clock5
    },
    {
        path: '/clock6',
        component: Clock6
    },
    {
        path: '/worldTime',
        component: WorldTime
    },
    {
        path: '/worldTime/detail',
        component: WorldTimeDetail
    },
    {
        path: '/stepTimer',
        component: StepTimer
    },
    {
        path: '*',
        component: Error404
    }
]

let router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js